import axios from 'axios';
import api from '../../config/config.json';
import { env } from '../../config/env';

const CONFIG = api[env];

export const postRegister = async (path: string, body: any) => {
  const sanitizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  const url = `${CONFIG.url_api}/api/register${sanitizedPath}`;
  try {
    const response = await axios.post(url, body, {
      timeout: 300000,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || { message: error?.message || 'Error en la solicitud' };
  }
};

export const getDiplomadosPublicos = async () => {
  const url = `${CONFIG.url_api}/api/register/diplomados`;
  const body = {
    page: 1,
    pageSize: 100
  };
  try {
    const response = await axios.post(url, body, {
      timeout: 300000,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || { message: error?.message || 'Error en la solicitud' };
  }
};

export const postRecoverPassword = async (body: any, token: string) => {
  const url = `${CONFIG.url_api}/api/register/recover`;
  try {
    const response = await axios.post(url, body, {
      timeout: 300000,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || { message: error?.message || 'Error en la solicitud' };
  }
};
